<button
  type="button"
  class="selected-procedure-button"
  [class.selected-procedure-button--read-only]="readOnly"
  [disabled]="!isInteractive"
  [class.expanded]="expanded"
  (click)="onButtonClick()"
>
  <div
    class="expanding-overlay"
    [class.expanded]="expanded"
    [style.height]="expandedHeight"
    [style.top]="expandedTop"
    [style.width]="expandedWidth"
    [style.left]="expandedLeft"
  ></div>
  <span class="procedure-name">{{ selectedProcedure?.Name | translate }}</span>
  <span *ngIf="isInteractive" class="chevron-icon">
    <tlk-chevron-down-icon *ngIf="!expanded" class="tlk-icon tlk-icon_size_l" />
    <tlk-chevron-up-icon *ngIf="expanded" class="tlk-icon tlk-icon_size_l" />
  </span>
</button>
